var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Select } from '@michelin/acid-components';
import { Controller, } from 'react-hook-form';
export function FormControlledSelect(props) {
    var name = props.name, rules = props.rules, control = props.control, label = props.label, options = props.options, readOnly = props.readOnly, error = props.error, helperText = props.helperText;
    return (React.createElement(Controller, { control: control, name: name, rules: rules, render: function (_a) {
            var field = _a.field;
            return (React.createElement(Select, __assign({ id: name, label: label, options: options, error: error, helperText: helperText, readOnly: readOnly, required: !!(rules === null || rules === void 0 ? void 0 : rules.required), fullWidth: true }, field)));
        } }));
}
//# sourceMappingURL=FormControlledSelect.js.map